import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	placeholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ariaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	ariaLabelGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	placeholder: {
		id: 'projects-directory-v3.page-layout.refinement-bar.project-category-picker.placeholder',
		defaultMessage: 'All categories',
		description: 'Placeholder that is showed inside the ProjectCategoryPicker',
	},
	ariaLabel: {
		id: 'projects-directory-v3.page-layout.refinement-bar.project-category-picker.aria-label',
		defaultMessage: 'Select a project category',
		description: 'Aria label for the ProjectCategoryPicker',
	},
	ariaLabelGalaxia: {
		id: 'projects-directory-v3.page-layout.refinement-bar.project-category-picker.aria-label-galaxia',
		defaultMessage: 'Select a space category',
		description: 'Aria label for the ProjectCategoryPicker',
	},
});
export default messages;
